/* External */
import { useEffect, useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import get from 'lodash-es/get';

/* Storage */
import { fetchContentById } from '../storage/contents';

/* Utils */
import useContent from './useContent';
import { STATUS_TYPES } from '../utils/constants';
import useRequestAndDelete from './useRequestAndDelete';

export default function useFetchContent({
  contentId,
  requiredProps = [],
  sourceProvider,
}) {
  const dispatchTrigger = useRef(false);
  const [requestId, setRequestId] = useState(undefined);
  const request = useRequestAndDelete(requestId);
  const dispatch = useDispatch();
  const content = useContent(contentId, sourceProvider);

  useEffect(() => {
    if (contentId) {
      dispatchTrigger.current = false;
    }
  }, [contentId]);

  useEffect(() => {
    const hasMissingProperties = !content || requiredProps.some((prop) => !get(content, prop));
    if (hasMissingProperties && contentId && !dispatchTrigger.current) {
      const regex = /^[\dA-Fa-f-]{36}/;
      const cleanContentId = contentId?.match(regex)?.[0] ?? '';

      const action = fetchContentById({ contentId: cleanContentId });

      setRequestId(action.requestId);
      dispatch(action);
      dispatchTrigger.current = true;
    }
  }, [contentId, content, dispatch, requiredProps]);

  if (request && request.status === STATUS_TYPES.FAILED_STATE) {
    return {
      isError: true,
      content,
    };
  }

  return {
    isFetching: request?.status === STATUS_TYPES.INIT_STATE,
    isError: false,
    content,
  };
}
